import { useState } from "react";
import { api, SITE_HOST } from "../api";
import { StatsTab } from "./StatsTab";
import { WebappsTab } from "./WebappsTab";
import { CustomersTab } from "./CustomersTab";
import { AdminsTab } from "./AdminsTab";
import { Logo } from "../components/Logo";

interface Props {
  meEmail: string;
  meId: string;
  onLogout: () => void;
}

type Tab = "stats" | "webapps" | "customers" | "admins";

export function Dashboard({ meEmail, meId, onLogout }: Props) {
  const [tab, setTab] = useState<Tab>("stats");

  async function logout() {
    try {
      await api.logout();
    } catch {
      // ignore
    }
    onLogout();
  }

  return (
    <div className="app">
      <div className="topbar">
        <a className="brand" href={`https://${SITE_HOST}`}>
          <Logo size={24} withDot title={SITE_HOST} />
          <h1>
            login<span className="muted" style={{ fontWeight: 400 }}>.mioe.com.tr</span>
            <span className="muted brand-sep"> · admin</span>
          </h1>
        </a>
        <div className="row" style={{ gap: 12 }}>
          <span className="muted">{meEmail}</span>
          <button className="secondary" onClick={logout}>Sign out</button>
        </div>
      </div>
      <div className="tabs">
        <button
          className={`tab ${tab === "stats" ? "active" : ""}`}
          onClick={() => setTab("stats")}
        >
          Stats
        </button>
        <button
          className={`tab ${tab === "webapps" ? "active" : ""}`}
          onClick={() => setTab("webapps")}
        >
          Webapps
        </button>
        <button
          className={`tab ${tab === "customers" ? "active" : ""}`}
          onClick={() => setTab("customers")}
        >
          Customers
        </button>
        <button
          className={`tab ${tab === "admins" ? "active" : ""}`}
          onClick={() => setTab("admins")}
        >
          Admins
        </button>
      </div>
      <div className="content">
        {tab === "stats" ? (
          <StatsTab />
        ) : tab === "webapps" ? (
          <WebappsTab />
        ) : tab === "customers" ? (
          <CustomersTab />
        ) : (
          <AdminsTab meId={meId} />
        )}
      </div>
    </div>
  );
}
